import { IFollowUpDocuments } from '../../../types';
export type IFollowUpDocumentsState = IFollowUpDocuments;

export enum DocActionTypes {
  TOGGLE_REQUIRED_DOCUMENTS = '@@student/follow_up_documents/TOGGLE_REQUIRED_DOCUMENTS',
  APPROVE_DOC = '@@student/follow_up_documents/APPROVE_DOC',
  TOGGLE_DOC_SUCCESS = '@@student/follow_up_documents/TOGGLE_DOC_SUCCESS',
  TOGGLE_DOC_FAILURE = '@@student/follow_up_documents/TOGGLE_DOC_FAILURE',
  REJECT_DOC = '@@student/follow_up_documents/REJECT_DOC',
  RESCIND_REJECT_DOC = '@@student/follow_up_documents/RESCIND_REJECT_DOC',
  DELETE_DOC = '@@student/follow_up_documents/DELETE_DOC',
  CUSTOM_DOCUMENT_REQUEST = '@@student/follow_up_documents/CUSTOM_DOCUMENT_REQUEST',
  ACKNOWLEDGE_DOC = '@@student/follow_up_documents/ACKNOWLEDGE_DOC',
}
